import React, { useState } from "react";
import { CommonButton, CommonModal, CommonStepIndicator } from "../Input";

// Sub-components
import Step1CustomerSelection from "./CreateSingleTransaction/Step1CustomerSelection";
import Step2ReceiverList from "./CreateSingleTransaction/Step2ReceiverList";
import Step3PaymentInfo from "./CreateSingleTransaction/Step3PaymentInfo";
import Step4ConfirmTransaction from "./CreateSingleTransaction/Step4ConfirmTransaction";
import Step5TransactionDenomination from "./CreateSingleTransaction/Step5TransactionDenomination";
import Step6TransactionReceipt from "./CreateSingleTransaction/Step6TransactionReceipt";
import CreateBeneficiaryModal from "../Beneficiaries/CreateBeneficiaryModal";

const CreateSingleTransactionModal = ({
  show,
  onHide,
  customer: initialCustomer,
  hideStep0 = false,
}) => {
  const [currentStep, setCurrentStep] = useState(hideStep0 ? 2 : 1);
  const [selectedReceivers, setSelectedReceivers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(initialCustomer);
  const [showCreateBeneficiaryModal, setShowCreateBeneficiaryModal] =
    useState(false);

  const handleToggleReceiver = (item) => {
    if (selectedReceivers.includes(item.id)) {
      setSelectedReceivers([]);
    } else {
      setSelectedReceivers([item.id]);
    }
  };

  const handleNext = () => {
    if (currentStep < 6) setCurrentStep(currentStep + 1);
  };

  const handleBack = () => {
    if (currentStep > (hideStep0 ? 2 : 1)) setCurrentStep(currentStep - 1);
  };

  const resetAndHide = () => {
    setCurrentStep(hideStep0 ? 2 : 1);
    setSelectedReceivers([]);
    setSelectedCustomer(initialCustomer);
    onHide();
  };

  const steps = [
    { id: 1, label: "Customer Selection" },
    { id: 2, label: "Receiver List" },
    { id: 3, label: "Payment Information" },
    { id: 4, label: "Confirm Transaction" },
    { id: 5, label: "Transaction Denomination" },
    { id: 6, label: "Transaction Receipt" },
  ];

  const displaySteps = hideStep0
    ? steps.filter((s) => s.id !== 1).map((s) => s.label)
    : steps.map((s) => s.label);
  const displayCurrentStep = hideStep0 ? currentStep - 1 : currentStep;

  return (
    <CommonModal
      show={show}
      onHide={resetAndHide}
      fullscreen={true}
      backdrop="static"
      headerClassName="bg-light-gray-soft px-5 pt-4 pb-2 border-bottom-0"
      bodyClassName="bg-light-gray-soft px-5 pb-5 pt-0"
      footerClassName="bg-light-gray-soft pb-4 pt-0 ps-5 pe-5 border-top-0"
      title={
        currentStep < 6 ? (
          <div className="w-100 pe-5">
            <CommonStepIndicator
              steps={displaySteps}
              currentStep={displayCurrentStep}
              width={750}
            />
          </div>
        ) : null
      }
      footer={
        currentStep < 6 ? (
          <div className="d-flex justify-content-end gap-3 w-100 mt-4">
            {currentStep === 2 && (
              <CommonButton
                variant="outline"
                className="px-5"
                onClick={() => setShowCreateBeneficiaryModal(true)}
              >
                Add
              </CommonButton>
            )}
            <CommonButton
              variant="outline"
              onClick={
                currentStep === (hideStep0 ? 2 : 1) ? resetAndHide : handleBack
              }
            >
              {currentStep === (hideStep0 ? 2 : 1) ? "Close" : "Back"}
            </CommonButton>
            <CommonButton
              className="px-5 fw-bold"
              style={{
                borderRadius: "8px",
              }}
              onClick={handleNext}
            >
              Next
            </CommonButton>
          </div>
        ) : null
      }
    >
      <div
        className={
          currentStep === 6
            ? "flex-grow-1 d-flex align-items-center justify-content-center"
            : ""
        }
        style={{ minHeight: "550px" }}
      >
        {currentStep === 1 && (
          <Step1CustomerSelection
            selectedCustomer={selectedCustomer}
            onSelectCustomer={(c) => {
              setSelectedCustomer(c);
              handleNext();
            }}
          />
        )}
        {currentStep === 2 && (
          <Step2ReceiverList
            selectedReceivers={selectedReceivers}
            onToggleReceiver={handleToggleReceiver}
          />
        )}
        {currentStep === 3 && <Step3PaymentInfo />}
        {currentStep === 4 && <Step4ConfirmTransaction />}
        {currentStep === 5 && <Step5TransactionDenomination />}
        {currentStep === 6 && (
          <Step6TransactionReceipt onClose={resetAndHide} />
        )}
      </div>

      <CreateBeneficiaryModal
        show={showCreateBeneficiaryModal}
        onHide={() => setShowCreateBeneficiaryModal(false)}
      />
    </CommonModal>
  );
};

export default CreateSingleTransactionModal;
